import MomentUtils from '@date-io/moment';
import { AppBar, Avatar, Button, Checkbox, Dialog as DialogMUI, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Fab, FormControl, FormControlLabel, Grid, Hidden, Icon, IconButton, ImageListItemBar, InputLabel, List, ListItem, ListItemSecondaryAction, ListItemText, MenuItem, OutlinedInput, Paper, Select, Slide, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Toolbar, Tooltip, Typography } from '@material-ui/core';
import { deepOrange, deepPurple, green, grey, red } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import classnames from 'classnames';
import jsPDF from 'jspdf';
import moment from 'moment';
import React, { Component } from "react";
import AutoCompleteSelection from '../components/AutoCompleteSelection';
import EnhancedTableHead from '../components/EnhancedTableHead';
import SelectDropdown from '../components/SelectDropdown';
import { RowCountOptions } from "../Config";
import "../css/shipment.css";
import { ROLES } from '../Roles';
import { FCService } from "../Services/FCService";
import { ItemService } from "../Services/ItemService";
import { OrganisationService } from "../Services/OrganisationService";
import { ShipmentService } from "../Services/ShipmentService";
import { WarehouseService } from "../Services/WarehouseService";
import { convertShipmentStatusToString, format, formatNumber, format_display, format_export_new, format_invoice, format_without_time, getShipmentStatusBadge, getTimeInIST, numberToText, precision, titleCase, toInt } from '../Utils';
import EnhancedTableToolbar from '../components/EnhancedTableToolbar';
import ViewListIcon from '@material-ui/icons/ViewList';
import LabelIcon from '@material-ui/icons/Label';
import ReceiptIcon from '@material-ui/icons/Receipt';
// import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import UploadIcon from '@material-ui/icons/CloudUpload';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import { STATES } from '../Constants'
import MyDialog from '../components/MyDialog';
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import ShipmentDetailExport from './ShipmentDetails'

const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

export const Transition = React.forwardRef((props, ref) => (
    <Slide direction="up" {...props} ref={ref} />
))

const styles = theme => ({
    appBar: {
        position: 'relative',
        marginBottom: 10
    },
    fab: {
        margin: theme.spacing(1),
        position: 'absolute',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto',
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    tablecell: {
        fontSize: '40pt',
        padding: '5px'
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom: '20px',
    },
    table: {
        minWidth: 700
    },
    list: {
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
    grid: {
        [theme.breakpoints.up('md')]: {
            marginTop: '10px',
        },
        marginTop: '50px',
        marginBottom: '5px'
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    qtyField: {
        width: "40%",
        position: "relative",
        [theme.breakpoints.up('md')]: {
            right: '100px',
            width: "10%",
            marginRight: 10
        },
        right: "22px"
    },
    icon: {
        padding: '0px',
        [theme.breakpoints.up('md')]: {
            padding: '12px',
        },
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
        },
    },
    formControlLeft: {
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
        },
    },
    orangeAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: deepOrange[500],
    },
    purpleAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: deepPurple[500],
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
    heading: {
        fontWeight: 500,
        color: 'black'
    }
});

class Shipment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            company_data: {
                pan: "",
                name: "",
                bill_to: "",
            },
            data: [],
            originalData: [],
            current_rows: [],
            numItemsPerPage: 10,
            currentPageNumber: 0,
            totalItems: 0,
            totalPages: 0,
            filter: '',
            new_shipment: { new: true, id: undefined, shipment_identifier: '', warehouse_id: "", fc_id: "", shipment_date: moment(), invoice_no: "", interstate: "1", vehicle_no: "", items: [] },
            show: false,
            showAddItem: false,
            showDetails: false,
            columns: [
                { id: 'index', numeric: false, disablePadding: true, label: '', sortable: false },
                { id: 'shipment_identifier', numeric: false, disablePadding: true, label: 'Shipment ID', sortable: true },
                { id: 'invoice_no', numeric: false, disablePadding: true, label: 'Invoice No', sortable: true },
                { id: 'warehouse_name', numeric: false, disablePadding: true, label: 'Warehouse', sortable: true },
                { id: 'fc_name', numeric: false, disablePadding: true, label: 'FC', sortable: true },
                { id: 'interstate', numeric: false, disablePadding: true, label: 'Interstate', sortable: true },
                { id: 'shipment_date', numeric: false, disablePadding: true, label: 'Shipment Date', sortable: true },
                { id: 'appointment', numeric: false, disablePadding: true, label: 'Appointment', sortable: false },
                { id: 'signed', numeric: false, disablePadding: true, label: 'Signed Doc', sortable: false },
                { id: 'status', numeric: false, disablePadding: true, label: 'Status', sortable: true },
                { id: 'actions', numeric: false, disablePadding: true, label: '', sortable: false },
            ],
            order: 'desc',
            orderBy: 'shipment_date',
            master_items: [],
            master_fc: [],
            master_warehouse: [],
            master_status: [{ id: '0', name: 'OnHold' }, { id: '1', name: 'InProgress' }, { id: '2', name: 'Completed' }, { id: '3', name: 'Cancelled' }],
            master_interstate: [{ id: '1', name: 'Interstate' }, { id: '0', name: 'Local' }],
            startDate: moment().subtract(1, "month"),
            endDate: moment().add(7, "days"),
            fc_names: [],
            project_names_master: [],
            selected_warehouse: "",
            selected_item_id: "",
            selected_status: "-1",
            selected_interstate: "",
            selected_fc: "",
            items_row: [],
            txn_type_row: [],
            showChangeStatus: false,
            selected_shipment: { status: "0" },
            error_fields: { shipment_identifier: false, warehouse_id: false, fc_id: false, shipment_date: false, invoice_no: false, vehicle_no: false },
            item_rows: [],
            output: '',
            showOutput: false,
            reload: false,
            selected: [],
            showShipmentDetails: false
        }

        this.handleSelect = this.handleSelect.bind(this);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.createModifyShipment = this.createModifyShipment.bind(this);

        //Sort
        this.sortBy = this.sortBy.bind(this);
        this.saveAppointment = this.saveAppointment.bind(this)
        this.uploadSignedDocument = this.uploadSignedDocument.bind(this)
        this.uploadAppointmentDocument = this.uploadAppointmentDocument.bind(this)
        this.downloadShippedDocument = this.downloadShippedDocument.bind(this)
        this.removeItemImage = this.removeItemImage.bind(this)
        this.refresh = this.refresh.bind(this)
        this.fileInput = React.createRef();
    }

    componentWillMount() {
        this.props.setTitle('Shipments');
        this.props.isLoading(true);
        this.fetchWarehouses();
        // this.fetchItems();
        this.fetchFCFilter();
        this.fetchItemFilter();
        this.fetchStatusFilter();
        this.fetchInterstateFilter();
        OrganisationService.getOrganisationDetails()
            .then(data => {
                this.setState({ company_data: data.organisation });
            })
    }

    fetchFCFilter = () => {
        FCService.getFCs()
            .then((data) => {
                let fc_names = data.fcs.map((fc) => (
                    <MenuItem key={fc.id} value={fc.id}>{fc.name}</MenuItem>
                ));
                fc_names.unshift(<MenuItem key={"-1"} value={"-1"}>All FCs</MenuItem>);
                this.setState({ master_fc: data.fcs, fc_names: fc_names });
                this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
    }

    fetchItemFilter = () => {
        ItemService.getItemList()
            .then((data) => {
                this.setState({ master_items: data.items });
                this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
    }

    fetchStatusFilter = () => {
        let txn_type_rows = this.state.master_status.map((txn_type) => (
            <MenuItem key={txn_type.id} value={txn_type.id}>{txn_type.name}</MenuItem>
        ));
        txn_type_rows.unshift(<MenuItem key={"-1"} value={"-1"}>All Status</MenuItem>);
        this.setState({ master_status: txn_type_rows });
    }

    fetchInterstateFilter = () => {
        let interstate_rows = this.state.master_interstate.map((option) => (
            <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
        ));
        interstate_rows.unshift(<MenuItem key={"-1"} value={"-1"}>All</MenuItem>);
        this.setState({ master_interstate_rows: interstate_rows });
    }

    fetchWarehouses() {
        WarehouseService.getWarehouses()
            .then((data) => {
                let warehouse_names = data.warehouses.map((w) => (
                    <MenuItem key={w.id} value={w.id}>{w.name}</MenuItem>
                ));
                warehouse_names.unshift(<MenuItem key={"-1"} value={"-1"}>All Warehouses</MenuItem>);
                this.setState({ master_warehouse: data.warehouses, warehouse_names: warehouse_names });
            })
            .catch((error) => {
                console.log("Error while fetching Warehouse list");
            });
    }

    componentDidMount() {
        this.fetchData(0, this.state.numItemsPerPage);
    }

    refresh() {
        this.setState({ reload: true })
        this.props.isLoading(true);
        ShipmentService.getShipmentById(this.state.shipment_details.id)
            .then(data => {
                let rows = this.shipmentItemDetailsRows(data);
                this.setState({ shipment_details: data, shipment_details_rows: rows });
            })
            .catch(error => console.log(error))
            .finally(() => this.props.isLoading(false))
    }

    sortBy = (event, property) => {
        const orderBy = property;
        let order = 'desc';
        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }
        this.setState({ order, orderBy }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage: event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangePage = (event, page) => {
        if (this.state.currentPageNumber > page) {
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    isSelected = (id) => {
        return this.state.selected.indexOf(id) !== -1;
    }

    handleClick = (event, id) => {
        const { selected } = this.state;
        const selectedIndex = this.state.selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({ selected: newSelected });
    };

    fetchData(start, numberItems, showLoading = true) {
        if (showLoading) {
            this.props.isLoading(true);
        }
        let sort = this.state.orderBy ? this.state.orderBy : '', direction = this.state.order ? this.state.order : '';
        let warehouse_id = this.state.selected_warehouse === "" ? null : this.state.selected_warehouse;
        let fc_id = this.state.selected_fc === "" ? null : this.state.selected_fc;
        let item_id = this.state.selected_item_id === "" ? null : this.state.selected_item_id;
        let status = this.state.selected_status === "-1" ? '0,1,2,3' : this.state.selected_status;
        let filter = this.state.filter === "" ? null : this.state.filter;
        let interstate = this.state.selected_interstate === "" ? null : this.state.selected_interstate;

        ShipmentService.getTotalCount(warehouse_id, fc_id, item_id, status, interstate, filter, moment.utc(this.state.startDate).format(format), moment.utc(this.state.endDate).format(format), 'v1')
            .then((data) => {
                this.setState({
                    totalItems: toInt(data.count),
                    totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
                });
                ShipmentService.getShipments(start, numberItems, moment.utc(this.state.startDate).format(format), moment.utc(this.state.endDate).format(format), warehouse_id, fc_id, interstate, status, item_id, filter, sort, direction)
                    .then((data) => {
                        this.setState({ data: data.shipments, originalData: data.shipments });
                        if (data.shipments) {
                            // data.shipments.forEach((shipment) => {
                            //     rows.push();
                            // });
                            this.setState({
                                current_rows: data.shipments
                            });
                        }
                        if (showLoading) {
                            this.props.isLoading(false);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        if (showLoading) {
                            this.props.isLoading(false);
                        }
                    });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleChangeShipmentDate = (date) => {
        this.setState(prevState => ({
            new_shipment: {
                ...prevState.new_shipment,
                shipment_date: date
            }
        }));
    }

    handleChange = (e) => {
        let change = this.state.new_shipment;
        if (e.target.name === 'interstate') {
            change[e.target.name] = e.target.checked ? '1' : '0';
        } else {
            change[e.target.name] = e.target.value;
        }
        let error_fields = this.state.error_fields;
        error_fields[e.target.name] = e.target.value ? false : true;

        this.setState({
            new_shipment: change,
            error_fields: error_fields
        });
    }

    edit = (e, shipment) => {
        if (shipment) {
            let items = JSON.parse(JSON.stringify(shipment.items));
            let rows = this.updateShipmentItemRows(items);
            this.setState({ new_shipment: { new: false, id: shipment.id, shipment_identifier: shipment.shipment_identifier, warehouse_id: shipment.warehouse_id, fc_id: shipment.fc_id, shipment_date: getTimeInIST(shipment.shipment_date), invoice_no: shipment.invoice_no, interstate: shipment.interstate, vehicle_no: shipment.vehicle_no, items: items }, item_rows: rows });
        }
        this.handleShow();
    }

    duplicateShipment = (e, s) => {
        let shipment = Object.assign({}, s);
        shipment.id = null;
        if (shipment) {
            let items = JSON.parse(JSON.stringify(shipment.items));
            let rows = this.updateShipmentItemRows(items);
            this.setState({ new_shipment: { new: true, id: undefined, shipment_identifier: '', warehouse_id: shipment.warehouse_id, fc_id: shipment.fc_id, shipment_date: getTimeInIST(shipment.shipment_date), invoice_no: shipment.invoice_no, interstate: shipment.interstate, vehicle_no: shipment.vehicle_no, items: items }, item_rows: rows });
        }
        this.handleShow();
    }

    handleClose() {
        this.setState({ show: false });
        this.setState({
            new_shipment: { new: true, id: undefined, shipment_identifier: '', warehouse_id: "", fc_id: "", shipment_date: moment(), invoice_no: "", interstate: "1", vehicle_no: "", items: [] },
            error_fields: { shipment_identifier: false, project_id: false, user_id: false, item_id: false, txn_type: false, qty: false, comments: false, vehicle_no: false },
            item_rows: []
        });
    }

    handleShow() {
        this.setState({ show: true });
    }

    showDetails = (e, shipment) => {
        let shipment_details = JSON.parse(JSON.stringify(shipment));
        let rows = this.shipmentItemDetailsRows(shipment_details);
        this.setState({ shipment_details: shipment_details, shipment_details_rows: rows });
        this.handleShowDetails();
    }

    removeShipment = (e, shipment) => {
        this.props.showConfirmDialog("Confirm remove shipment?", undefined, () => {
            ShipmentService.removeShipment(shipment.id)
                .then(data => {
                    this.props.showSnackBar('Removed Shipment.', 'success');
                    this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage, false);
                })
                .catch(error => {
                    this.props.showSnackBar('Could not remove shipment. Please try again or contact admin.', 'error');
                });
            this.props.closeConfirmDialog();
        });
    }

    handleShowDetails = () => {
        this.setState({ showDetails: true });
    }

    handleCloseDetails = () => {
        this.setState({
            showDetails: false,
            shipment_details: null,
            shipment_details_rows: []
        });
        if (this.state.reload) {
            this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
            this.setState({ reload: false });
        }
    }

    shipmentItemDetailsRows = (shipment_details) => {
        let items = shipment_details.items;
        return items.filter(i => toInt(i.status) !== -1).map(item => (
            <ItemDisplayDetails key={item.item_id} item={item} interstate={shipment_details.interstate === 1} master_items={this.state.master_items} {...this.props} refresh={this.refresh} />
        ));
    }

    confirmSave = () => {
        let new_shipment = this.state.new_shipment;
        new_shipment.is_new = new_shipment.new;
        new_shipment.shipment_date = moment(new_shipment.shipment_date).utc().format(format);
        this.props.isLoading(true);
        let headers = { user_id: this.props.user.id };
        ShipmentService.createShipment(headers, new_shipment)
            .then((response) => {
                this.props.closeConfirmDialog();
                this.props.isLoading(false);
                this.handleClose();
                this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
                this.props.showSnackBar(`Shipment created.`, 'success');
            })
            .catch(error => {
                if (error.error_shipment_id) {
                    this.props.showSnackBar(error.errorMessage, 'error');
                } else if (error.error_invoice_no) {
                    this.props.showSnackBar(error.errorMessage, 'error');
                } else {
                    this.props.showSnackBar(`Something went wrong. Please try again later.`, 'error');
                }
                this.props.closeConfirmDialog();
                this.props.isLoading(false);
            });
    }

    createModifyShipment(e) {
        e.preventDefault();
        let new_shipment = this.state.new_shipment;
        // new_shipment.shipment_date = moment(new_shipment.shipment_date).format(format);
        // new_shipment.items = new_shipment.items.filter(i => ( (i.case_size || 0) > 0) && ((i.no_of_cases || 0) > 0) && ((i.weight || 0) > 0));
        let error_fields = this.state.error_fields;
        if (new_shipment.shipment_identifier && new_shipment.warehouse_id && new_shipment.fc_id && new_shipment.invoice_no && new_shipment.items.length > 0 && new_shipment.items.filter(i => ((i.case_size || 0) > 0) && ((i.no_of_cases || 0) > 0) && ((i.weight || 0) > 0)).length === new_shipment.items.length) {
            // && moment(new_shipment.shipment_date) >= moment().startOf('day')
            this.setState({ new_shipment: new_shipment }, () => this.props.showConfirmDialog("Create Shipment?", "Confirm", this.confirmSave));
            return;
        }

        if (!new_shipment.shipment_identifier) {
            error_fields.shipment_identifier = true;
        }
        if (!new_shipment.warehouse_id) {
            error_fields.warehouse_id = true;
        }
        if (!new_shipment.fc_id) {
            error_fields.fc_id = true;
        }

        if (!new_shipment.invoice_no) {
            error_fields.invoice_no = true;
        }
        // if(!(moment(new_shipment.shipment_date) >= moment().startOf('day'))){
        //     error_fields.shipment_date = true;
        // }
        if (new_shipment.items.length === 0 || new_shipment.items.filter(i => ((i.case_size || 0) > 0) && ((i.no_of_cases || 0) > 0) && ((i.weight || 0) > 0)).length !== new_shipment.items.length) {
            this.props.showSnackBar('Please add items, their quantities and proceed', 'error');
        }
        this.setState({ error_fields: error_fields });
    }

    handleSelect(eventKey, e) {
        if (eventKey === 'prev') {
            if ((this.state.currentPageNumber) > 0) {
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if (eventKey === 'next') {
            if ((this.state.currentPageNumber) < this.state.totalPages) {
                this.fetchRow(this.state.currentPageNumber + 1);
            }
        }
    }

    fetchRow(newCurrentPage) {
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    handleChangeSearchText = (e) => {
        this.setState({ filter: e.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, true));
    }

    handleWarehouseSelection = (e) => {
        this.setState({ selected_warehouse: e.target.value }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleFCSelection = (e) => {
        this.setState({ selected_fc: e.target.value }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleStatusSelection = (e) => {
        this.setState({ selected_status: e.target.value }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleInterstateSelection = (e) => {
        this.setState({ selected_interstate: e.target.value }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeStartDate = (date) => {
        console.log(date);
        this.setState({
            startDate: date,
        }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeEndDate = (date) => {
        this.setState({
            endDate: date,
        }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    changeStatus = (event, shipment) => {
        if (this.props.user.roles.includes(ROLES.ADMIN)) {
            if (shipment.status !== '2' && shipment.status !== '3') {
                this.setState({ selected_shipment: shipment }, () => this.handleShowChangeStatus());
            } else {
                this.props.showSnackBar('Cannot change state of an Completed or Cancelled shipment', 'warning');
            }
        }
    }

    handleShowChangeStatus = () => {
        this.setState({ showChangeStatus: true });
    }

    handleCloseChangeStatus = () => {
        this.setState({ showChangeStatus: false, selected_shipment: { status: "0" } });
    }

    changeStatusForShipment = (e) => {
        this.props.showConfirmDialog("Confirm change status?", undefined, () => {
            let headers = { user_id: this.props.user.id };
            ShipmentService.changeShipmentStatus(headers, { id: this.state.selected_shipment.id, status: e.target.value })
                .then((data) => {
                    this.props.showSnackBar(`Changed status of Shipment`, 'success');
                    this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage, false);
                    this.props.closeConfirmDialog();
                    this.handleCloseChangeStatus();
                })
                .catch(error => {
                    console.log(error);
                    this.props.showSnackBar(`Failed to change status. Please try again.`, 'error');
                });
        });
    }

    removeItem = (e, item) => {
        if (toInt(item.no_of_cases) !== 0) {
            this.props.showConfirmDialog("Confirm Remove?", undefined, () => {
                this.confirmRemove(item, this.props.closeConfirmDialog);
            });
        } else {
            this.confirmRemove(item, undefined);
        }
    }

    confirmRemove = (item, callback) => {
        let items = this.state.new_shipment.items;

        if (this.state.new_shipment.new) {
            items = items.filter((i) => i.item_id !== item.item_id);
        } else {
            let i = items.filter((i) => i.item_id === item.item_id)[0];
            i.status = "-1";
        }
        this.setState((prevState) => ({
            new_shipment: {
                ...prevState.new_shipment,
                items: items
            },
            item_rows: this.updateShipmentItemRows(items)
        }), () => callback ? callback() : null);
    }

    handleItemChange = (e, field) => {
        let i = this.state.new_shipment.items;
        let item = i.filter((i) => i.item_id === e.target.name);
        if (item.length === 1) {
            item[0][field] = e.target.value;
        }
        this.setState((prevState) => ({
            new_shipment: {
                ...prevState.new_shipment,
                items: i
            }
        }));
    }

    updateShipmentItemRows = (items) => {
        return items.filter(i => toInt(i.status) !== -1).map(item => (
            <ItemDetails key={item.item_id} item={item} master_items={this.state.master_items} handleItemChange={this.handleItemChange} removeItem={this.removeItem} classes={this.props.classes} />
        ));
    }

    handleAddItemClick = () => {
        if (this.state.master_items.filter((item) => this.state.new_shipment.items.filter((i) => i.item_id === item.id && toInt(i.status) === 1).length === 0).length > 0) {
            this.setState({ showAddItem: true });
        } else {
            this.props.showSnackBar(`No more Items left to add.`, 'info');
        }
    }

    handleShowAddItemShipment = () => {
        this.setState({ showAddItem: true });
    }

    handleCloseAddItemShipment = () => {
        this.setState({ showAddItem: false });
    }

    handleAddItemToShipment = (e) => {
        let item = this.state.master_items.filter(i => i.id === e.id)[0];
        let error_fields = this.state.error_fields;
        if (item) {
            let i = {
                item_id: item.id,
                item_name: item.name,
                case_size: "0",
                no_of_cases: "0",
                weight: "0",
                status: "1",
                rate: item.rate,
                igst: item.igst,
                cgst: item.cgst,
                sgst: item.sgst
            }
            let items = this.state.new_shipment.items;
            items = items.filter(i => i.item_id !== item.id);
            items.push(i);
            error_fields.items = items.length === 0 ? true : false;
            this.setState((prevState) => ({
                new_shipment: {
                    ...prevState.new_shipment,
                    items: items
                },
                error_fields: error_fields,
                item_rows: this.updateShipmentItemRows(items)
            }), () => this.handleCloseAddItemShipment());
        }
    }

    handleCloseOutput = () => {
        this.setState({ showOutput: false, output: '' });
    }

    handleShowOutput = () => {
        this.setState({ showOutput: true });
    }

    showPackingList = (e, shipment) => {
        var doc = new jsPDF({
            orientation: 'portrait',
            format: 'a4',
            compress: true
        });
        doc.cellInitialize();
        doc.setFontSize(14);
        doc.setLineHeightFactor(0.5);
        doc.setFont("times", 'bold');
        let c = 1;
        let data = [];

        shipment.items.forEach(item => {
            let i = 1;
            for (; i <= item.no_of_cases; i++) {
                let fnsku = this.state.master_items.filter(i => i.id === item.item_id)[0].fnsku;
                data.push({ "item": item.item_name, "carton_no": `${c++}`, "fnsku": fnsku, "case_size": toInt(item.case_size) + "pcs", "weight": item.weight + " KG", "dimension": item.dimension || "-" });
            }
        });

        doc.text("Packing List", 10, 10);
        doc.cell(10, 20, 60, 10, "Shipment ID", 1, "center");
        doc.cell(10, 20, 60, 10, shipment.shipment_identifier || '', 1, "center");
        doc.cell(10, 20, 60, 10, "Invoice No", 2, "center");
        doc.cell(10, 20, 60, 10, shipment.invoice_no, 2, "center");
        doc.cell(10, 20, 60, 10, "Shipment Date", 3, "center");
        doc.cell(10, 20, 60, 10, getTimeInIST(shipment.shipment_date).format(format_invoice), 3, "center");
        doc.cell(10, 20, 60, 10, "Warehouse", 4, "center");
        doc.cell(10, 20, 60, 10, shipment.warehouse_name, 4, "center");
        doc.cell(10, 20, 60, 10, "Fulfillment Center", 5, "center");
        doc.cell(10, 20, 60, 10, shipment.fc_name, 5, "center");

        var header = [
            {
                'name': 'item',
                'prompt': "Item",
                'width': 100,
                'align': 'center',
                'padding': 0
            }, {
                'name': 'carton_no',
                'prompt': "Carton \n\nNo.",
                'width': 27,
                'align': 'right',
                'padding': 0
            }, {
                'name': "fnsku",
                'prompt': "FNSKU",
                'width': 45,
                'align': 'center',
                'padding': 0
            }, {
                'name': "case_size",
                'prompt': "Case Size",
                'width': 32,
                'align': 'center',
                'padding': 0
            }, {
                'name': 'weight',
                'prompt': 'Weight',
                'width': 25,
                'align': 'right',
                'padding': 0
            }, {
                'name': 'dimension',
                'prompt': 'dimension',
                'width': 38,
                'align': 'left',
                'padding': 0
            }];

        doc.table(5, 100, data, header, { headerBackgroundColor: [255, 255, 255], autoSize: false });

        let filename = `${shipment.shipment_identifier || ''}_${shipment.fc_name}_GST${shipment.invoice_no.substring(shipment.invoice_no.lastIndexOf("/") + 1)}_PackingList.pdf`;
        doc.save(filename);
        // function open_data_uri_window(url, filename) {
        //     var html = '<html>' +
        //         '<style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style>' +
        //         '<body>' +
        //         '<iframe src="' + url + '" download="abhi.pdf"></iframe>' +
        //         '<a href="'+url+'" download="'+filename+'"></a>' +
        //         '</body></html>';
        //     var a = window.open("about:blank", "Zupfnoter");
        //     a.document.write(html);
        //     a.document.close();
        // }

        // let a = doc.output('datauristring', {filename: filename});
        // open_data_uri_window(a, filename);
    }

    printLabel = (e, shipment) => {
        // this.handleShowOutput();
        var doc = new jsPDF({
            orientation: 'landscape',
            format: 'a6',
            compress: true
        });
        // doc.cellInitialize();
        doc.setFontSize(14);
        // doc.setLineHeightFactor(0.5);
        doc.setFont("times", 'bold')
        let c = 1;
        let label_data = [];

        shipment.items.forEach(item => {
            let i = 1;
            for (; i <= item.no_of_cases; i++) {
                label_data.push([{ x: "Shipment ID:", y: shipment.shipment_identifier || '' }, { x: "FC Name:", y: shipment.fc_name }, { x: "Carton No.", y: '' + c++ }, { x: "Carton Weight:", y: item.weight + " KG" }, { x: "Item Name:", y: item.item_name }, { x: "Total Qty", y: toInt(item.case_size) + "pcs" }]);
            }
        });
        label_data.forEach((e, i) => {
            e.forEach((element, index) => {
                doc.cell(10, 10, 60, 10, element.x, index, "center");
                doc.cell(10, 10, 60, 10, element.y, index, "center");
            });
            if (i < label_data.length - 1) {
                doc.cellAddPage();
            }
        });
        //   doc.output("dataurlnewwindow");
        // doc.save("Labels-"+shipment.id);
        // doc.setDocumentProperties({
        //         'title': 'Labellllll.pdf'
        // })
        let filename = `${shipment.shipment_identifier || ''}_${shipment.fc_name}_GST${shipment.invoice_no.substring(shipment.invoice_no.lastIndexOf("/") + 1)}_Labels.pdf`;
        // doc.output("dataurlnewwindow",{filename: filename});
        // let output = doc.output('datauristring', {filename: filename});
        // this.setState({output: output});
        doc.save(filename);

        // function open_data_uri_window(url, filename) {
        //     var html = '<html>' +
        //         '<style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style>' +
        //         '<body>' +
        //         '<iframe src="' + url + '" download="abhi.pdf"></iframe>' +
        //         '<a href="'+url+'" download="'+filename+'"></a>' +
        //         '</body></html>';
        //     var a = window.open("about:blank", "Zupfnoter");
        //     a.document.write(html);
        //     a.document.close();
        // }

        // let a = doc.output('datauristring', {filename: filename});
        // open_data_uri_window(a, filename);

    }

    printInvoice = (e, shipment) => {
        // this.handleShowOutput();
        let company = this.state.company_data;
        var doc = new jsPDF({
            orientation: 'portrait',
            format: 'a4',
            compress: true
        });

        //Initial
        // Delivery Challan
        let startX = 10;
        let startY = 10;
        let endX = doc.internal.pageSize.width - 20;
        let endY = doc.internal.pageSize.height - 20;
        let contentEndX = endX + 10;
        let contentEndY = endY + 10;
        let contentcenter = startX + (contentEndX - 10) / 2;

        let warehouse = this.state.master_warehouse.filter(w => w.id === shipment.warehouse_id)[0];
        let fc = this.state.master_fc.filter(fc => fc.id === shipment.fc_id)[0];
        const total_cartons = shipment.items.reduce(function (items, item, idx) {
            return items + toInt(item.no_of_cases)
        }, 0);
        const total_units = shipment.items.reduce(function (items, item, idx) {
            return items + (toInt(item.no_of_cases) * toInt(item.case_size))
        }, 0);
        //Heading Section

        doc.setFontSize(14);
        doc.setLineHeightFactor(0.5);

        startX = 10;
        startY = 20;
        endX = doc.internal.pageSize.width - 20;
        endY = doc.internal.pageSize.height - 20;
        doc.setLineWidth(0.25)
        doc.rect(startX, 10, endX, startY);
        doc.rect(startX, startY + 10, endX, startY + 20);
        doc.rect(startX, startY + 50, endX, startY + 20);

        doc.setFont("times", '', 'normal')
        doc.setFontSize(14);
        doc.setFont("times", 'bold')
        //SECTION 1
        doc.text(company.name, contentcenter, 16, { align: "center", maxWidth: contentEndX - 10 });
        doc.setFontSize(10);
        doc.setFont("times", '', 'normal')
        doc.text(`${warehouse.address1 ? `${warehouse.address1}, ` : ''}${warehouse.address2 ? `${warehouse.address2}, ` : ''}${warehouse.city ? `${warehouse.city}, ` : ''}${warehouse.district ? `${warehouse.district}, ` : ''}${warehouse.state ? `${warehouse.state} ` : ''}${warehouse.pin ? `- ${warehouse.pin}` : ''}`, contentcenter, 21, { align: "center", maxWidth: contentEndX - 10 });
        doc.setFont("times", 'bold')
        doc.text(`DELIVERY CHALLAN/ TAX INVOICE`, contentcenter, startY + 7, { align: "center", maxWidth: contentEndX - 10 });
        //SECTION 2
        doc.setFont("times", '', 'normal')
        doc.setFontSize(8);
        doc.setFont("times", 'bold')
        doc.text(`Ship From:`, startX + 5, startY + 17, { align: "left", maxWidth: contentEndX / 3 });
        doc.setFont("times", '', 'normal')
        doc.setFontSize(8);
        doc.setFont("times", '', 'normal')
        let billFrom = startY + 22
        let vhDiff = 4
        doc.text(warehouse.name, startX + 5, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        billFrom += vhDiff
        doc.text(warehouse.address1, startX + 5, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        if (warehouse.address2) {
            billFrom += vhDiff
            doc.text(warehouse.address2, startX + 5, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        }
        if (warehouse.city || warehouse.district) {
            billFrom += vhDiff
            doc.text(`${warehouse.city ? `${warehouse.city}, ` : ''}${warehouse.district ? `${warehouse.district}, ` : ''}`, startX + 5, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        }
        billFrom += vhDiff
        let state = STATES.find(x => x.label === warehouse.state);
        doc.text(`${state ? `${state.label}(State/UT Code: ${state.state_code})` : ''}`, startX + 5, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        billFrom += vhDiff
        doc.text(warehouse.pin, startX + 5, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        billFrom += vhDiff
        doc.setFont("times", 'bold')
        doc.text(`GSTIN`, startX + 5, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        doc.setFont("times", '', 'normal')
        doc.text(warehouse.gst, startX + 5 + 10, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        // Ship To
        let billFromX = startX + 5 + contentEndX / 3 - 15
        doc.setFont("times", 'bold')
        doc.text(`Ship To:`, billFromX, startY + 17, { align: "left", maxWidth: contentEndX / 3 });
        doc.setFont("times", '', 'normal')
        billFrom = startY + 22
        doc.text(fc.name, billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        billFrom += vhDiff
        doc.text(fc.address1, billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        if (fc.address2) {
            billFrom += vhDiff
            doc.text(fc.address2, billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        }
        if (fc.address3) {
            billFrom += vhDiff
            doc.text(fc.address3, billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        }
        billFrom += vhDiff
        state = STATES.find(x => x.label === fc.address4);
        doc.text(`${state ? `${state.label}(State/UT Code: ${state.state_code})` : ''}`, billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        billFrom += vhDiff
        doc.setFont("times", 'bold')
        doc.text(`GSTIN`, billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        doc.setFont("times", '', 'normal')
        doc.text(fc.gstin, billFromX + 10, billFrom, { align: "left", maxWidth: contentEndX / 3 });

        billFromX = startX + 5 + (contentEndX * 2 / 3) - 15
        billFrom = startY + 30
        doc.setFont("times", 'bold')
        doc.text('Place of supply :', billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        doc.setFont("times", '', 'normal')
        doc.text(`${state ? `${state.label}(State/UT Code: ${state.state_code})` : ''}`, billFromX + 22, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        billFrom += vhDiff
        doc.setFont("times", 'bold')
        doc.text('Place of supply :', billFromX, billFrom, { align: "left", maxWidth: contentEndX / 3 });
        doc.setFont("times", '', 'normal')
        doc.text(`${state ? `${state.label}(State/UT Code: ${state.state_code})` : ''}`, billFromX + 22, billFrom, { align: "left", maxWidth: contentEndX / 3 });

        //SECTION 3
        let section3X = startX + 5
        let section3Y = billFrom + 20
        let vwDiff = 40
        vhDiff = 0
        doc.setFont("times", '', 'normal')
        doc.setFontSize(8);
        doc.setFont("times", '', 'normal')
        doc.text(`Document Number`, section3X, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
        doc.text(`${shipment.shipment_identifier || ''}`, section3X + vwDiff, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
        vhDiff += 4
        doc.text(`FBA Shipment ID`, section3X, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
        doc.text(`${shipment.shipment_identifier || ''}`, section3X + vwDiff, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
        vhDiff += 4
        doc.text(`IRN Number (Optional)`, section3X, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
        doc.text(`${''}`, section3X + vwDiff, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
        vhDiff += 4
        doc.text(`Invoice Number`, section3X, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
        doc.text(`${shipment.invoice_no}`, section3X + vwDiff, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
        vhDiff += 4
        doc.text(`Document Date`, section3X, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
        doc.text(`${getTimeInIST(shipment.shipment_date).format(format_invoice)}`, section3X + vwDiff, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
        vhDiff += 4
        doc.text(`Purpose of transfer`, section3X, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
        doc.text(`Stock Transfer`, section3X + vwDiff, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
        vhDiff += 4
        doc.text(`Number of box`, section3X, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });
        doc.text(`${total_cartons}`, section3X + vwDiff, section3Y + vhDiff, { align: "left", maxWidth: contentEndX / 3 });

        // Section 4
        let section4X = startX
        let section4Y = section3Y + vhDiff + 2
        let igstBilling = shipment.interstate === 1
        let data = []
        let tq = 0, uv = 0, tv = 0, iv = 0, sv = 0, cv = 0
        shipment.items.forEach((item, i) => {
            // let i = 1;
            // for(; i <= item.no_of_cases ; i++){
            let totalQty = (toInt(item.no_of_cases) * toInt(item.case_size))
            tq += totalQty
            uv += parseFloat(item.rate || 0)
            tv += parseFloat(parseFloat(item.rate || 0) * parseFloat(totalQty))
            cv += parseFloat(igstBilling ? 0 : ((parseFloat(totalQty) * parseFloat(item.rate)) * parseFloat(item.cgst || 0) / 100))
            sv += parseFloat(igstBilling ? 0 : ((parseFloat(totalQty) * parseFloat(item.rate)) * parseFloat(item.sgst || 0) / 100))
            iv += parseFloat(igstBilling ? ((parseFloat(totalQty) * parseFloat(item.rate)) * parseFloat(item.igst || 0) / 100) : 0)
            data.push({
                "index": `${i + 1}`,
                "item": `${item.item_name}`,
                "qty": `${totalQty || 0}`,
                "unit_value": `${formatNumber(item.rate || 0)}`,
                "hsn": `${item.hsn_code}`,
                "total_value": `${formatNumber((item.rate || 0) * totalQty)}`,
                "cgst_rate": `${igstBilling ? 0 : formatNumber(item.cgst)}`,
                "cgst_value": `${igstBilling ? 0 : formatNumber((totalQty * item.rate) * parseFloat(item.cgst || 0) / 100)}`,
                "sgst_rate": `${igstBilling ? 0 : formatNumber(item.sgst)}`,
                "sgst_value": `${igstBilling ? 0 : formatNumber((totalQty * item.rate) * parseFloat(item.sgst || 0) / 100)}`,
                "igst_rate": `${igstBilling ? formatNumber(item.igst) : 0}`,
                "igst_value": `${igstBilling ? formatNumber((totalQty * item.rate) * parseFloat(item.igst || 0) / 100) : 0}`,
            });
            // }
        });

        data.push({
            "index": `   `,
            "item": `Total`,
            "qty": `${tq || 0}`,
            "unit_value": `${formatNumber(uv || 0)}`,
            "hsn": `   `,
            "total_value": `${formatNumber(tv || 0)}`,
            "cgst_rate": `   `,
            "cgst_value": `${formatNumber(cv || 0)}`,
            "sgst_rate": `   `,
            "sgst_value": `${formatNumber(sv || 0)}`,
            "igst_rate": `  `,
            "igst_value": `${formatNumber(iv || 0)}`,
        })

        let header = [
            {
                'name': 'index',
                'prompt': "Sno",
                'width': 13,
                'align': 'left',
                'padding': 0
            }, {
                'name': 'item',
                'prompt': "Product Description",
                'width': 55.5,
                'align': 'left',
                'padding': 0
            }, {
                'name': 'qty',
                'prompt': "Qty",
                'width': 15,
                'align': 'left',
                'padding': 0
            }, {
                'name': "unit_value",
                'prompt': "Unit\n\nValue",
                'width': 20,
                'align': 'center',
                'padding': 0
            }, {
                'name': "hsn",
                'prompt': "HSN /\n\nSAC\n\nCode",
                'width': 21,
                'align': 'left',
                'padding': 0
            }, {
                'name': 'total_value',
                'prompt': 'Total\n\nValue\n\n(INR)',
                'width': 22,
                'align': 'left',
                'padding': 0
            }, {
                'name': 'cgst_rate',
                'prompt': 'CGST\n\nRate\n\n(%)',
                'width': 16,
                'align': 'left',
                'padding': 0
            }, {
                'name': 'cgst_value',
                'prompt': 'CGST\n\nValue\n\n(INR)',
                'width': 20,
                'align': 'left',
                'padding': 0
            }, {
                'name': 'sgst_rate',
                'prompt': 'SGST\n\nRate\n\n(%)',
                'width': 16,
                'align': 'left',
                'padding': 0
            }, {
                'name': 'sgst_value',
                'prompt': 'SGST\n\nValue\n\n(INR)',
                'width': 20,
                'align': 'left',
                'padding': 0
            }, {
                'name': 'igst_rate',
                'prompt': 'IGST\n\nRate\n\n(%)',
                'width': 15,
                'align': 'left',
                'padding': 0
            }, {
                'name': 'igst_value',
                'prompt': 'IGST\n\nValue\n\n(INR)',
                'width': 20,
                'align': 'left',
                'padding': 0
            }];

        let section5Y = section4Y + 5

        doc.table(section4X, section4Y, data, header, {
            headerBackgroundColor: "#FFFFFF",
            autoSize: false,
            fontSize: 6,
            rowStart: (e) => {
                section5Y += 8
                if (e.row === data.length - 1) {
                    doc.setFont("times", 'bold');
                }
                else {
                    doc.setFont("times", '', 'normal');
                }
            },
        });


        // console.log("currentw", doc.internal.pageSize.getHeight())
        let section5AY = section5Y + 3 + (data.length > 5 ? 0 : 3);
        doc.rect(startX, section5AY, endX, 7);
        doc.setFontSize(8)
        doc.setFont('times', 'bold')
        doc.text(`Total Value of Goods Incl. Tax INR ${formatNumber((parseFloat(tv) + parseFloat(sv) + parseFloat(cv) + parseFloat(iv)) || 0)}`, startX + 10, section5AY + 5)

        // Section 6
        let section6Y = section5Y + 10 + 5
        doc.rect(startX, section6Y, endX, 23);
        doc.text(`Declaration`, contentcenter, section6Y + 6, { align: "center", width: contentEndY })
        doc.setFont('times', '', 'normal')
        doc.text(`We declare that`, startX + 5, section6Y + 9, { align: "left", width: contentEndY })
        doc.text(`1. The above mentioned goods are being moved from our premises for branch transfer`, startX + 7, section6Y + 14, { align: "left", width: contentEndY })
        doc.text(`2. The above mentioned details are true and correct to the best of our knowledge`, startX + 7, section6Y + 19, { align: "left", width: contentEndY })
        doc.rect(startX, section6Y + 23, endX, 40);
        doc.setFont('times', 'bold')
        doc.text(`For ${company.name}`, startX + 10, section6Y + 30, { align: "left", width: contentEndY })
        doc.setFont('times', '', 'normal')
        doc.text(`Authorized Signatory`, startX + 13, section6Y + 60, { align: "left", width: contentEndY })

        // Next Page - Packaging list
        doc.cellAddPage()
        doc.setFontSize(12);
        // doc.setLineWidth(0.75)
        doc.setLineHeightFactor(1);
        doc.setFont("times", 'bold')
        let c = 1;
        data = [];

        shipment.items.forEach(item => {
            let i = 1;
            for (; i <= item.no_of_cases; i++) {
                let fnsku = this.state.master_items.filter(i => i.id === item.item_id)[0].fnsku;
                data.push({ "item": item.item_name, "carton_no": `${c++}`, "fnsku": fnsku, "case_size": toInt(item.case_size) + "pcs", "weight": item.weight + " KG", "dimension": item.dimension || "-" });
            }
        });

        doc.text("Packing List", 10, 10);
        doc.cell(10, 20, 60, 10, "Shipment ID", 1);
        doc.cell(10, 20, 60, 10, shipment.shipment_identifier || '', 1, "center");
        doc.cell(10, 20, 60, 10, "Invoice No", 2, "center");
        doc.cell(10, 20, 60, 10, shipment.invoice_no, 2, "center");
        doc.cell(10, 20, 60, 10, "Shipment Date", 3, "center");
        doc.cell(10, 20, 60, 10, getTimeInIST(shipment.shipment_date).format(format_invoice), 3, "center");
        doc.cell(10, 20, 60, 10, "Warehouse", 4, "center");
        doc.cell(10, 20, 60, 10, shipment.warehouse_name, 4, "center");
        doc.cell(10, 20, 60, 10, "Fulfillment Center", 5, "center");
        doc.cell(10, 20, 60, 10, shipment.fc_name, 5, "center");

        header = [
            {
                'name': 'item',
                'prompt': "Item",
                'width': 95,
                'align': 'left',
            }, {
                'name': 'carton_no',
                'prompt': "Carton No.",
                'width': 32,
                'align': 'left',
            }, {
                'name': "fnsku",
                'prompt': "FNSKU",
                'width': 45,
                'align': 'left',
            }, {
                'name': "case_size",
                'prompt': "Case Size",
                'width': 32,
                'align': 'center',
            }, {
                'name': 'weight',
                'prompt': 'Weight',
                'width': 27,
                'align': 'center',
            }, {
                'name': 'dimension',
                'prompt': 'Dimension',
                'width': 38,
                'align': 'center',
            }];

        doc.table(5, 100, data, header, { autoSize: false, fontSize: 10, padding: 4 });

        // Next Page - Invoice
        doc.addPage('a4', "p")
        startX = 10;
        startY = 10;
        endX = doc.internal.pageSize.width - 20;
        endY = doc.internal.pageSize.height - 20;
        doc.rect(startX, startY, endX, endY);

        //Heading Section
        contentEndX = endX + 10;
        contentEndY = endY + 10;
        let headingHeight = 50;
        let footerheightY = contentEndY - 50;
        let footerTotalHeightY = contentEndY - 40;
        doc.line(startX, headingHeight, contentEndX, headingHeight);
        contentcenter = startX + (contentEndX - 10) / 2;

        doc.setFont("times", '', 'normal')
        doc.setFontSize(14);
        doc.text(`${shipment.interstate === 1 ? 'TAX INVOICE' : 'Delivery Challan'}`, contentcenter, startX + 8, { align: "center", maxWidth: contentEndX - 10 });
        doc.setFont("times", 'bold')
        doc.setFontSize(32);
        doc.text(company.name, contentcenter, startX + 19, { align: "center", maxWidth: contentEndX - 10 });
        doc.setFont("times", '', 'normal')
        doc.setFontSize(12);
        doc.text(warehouse.address1, contentcenter, startX + 25, { align: "center", maxWidth: contentEndX - 10 });
        doc.text(`${warehouse.address2 ? `${warehouse.address2}, ` : ''}${warehouse.city ? `${warehouse.city}, ` : ''}${warehouse.district ? `${warehouse.district}, ` : ''}${warehouse.state ? `${warehouse.state} ` : ''}${warehouse.pin ? `- ${warehouse.pin}` : ''}`, contentcenter, startX + 30, { align: "center", maxWidth: contentEndX - 10 });
        doc.setFont("times", 'bold')
        doc.text(`GSTIN No ${warehouse.gst}`, contentcenter, startX + 37, { align: "center", maxWidth: contentEndX - 10 });


        //Bill to, Invoice, Date Section
        let section2Height = headingHeight + 45;
        let invoiceStartX = contentEndX - 65;
        let invoiceStartY = headingHeight + 20;
        doc.line(startX, section2Height, contentEndX, section2Height);
        doc.line(invoiceStartX, invoiceStartY, contentEndX, invoiceStartY);
        doc.line(invoiceStartX, headingHeight, invoiceStartX, section2Height);

        // Bill To
        doc.setFont("times", 'bold')
        doc.setFontSize(12);
        doc.text('Bill To:', startX + 2, headingHeight + 5, { align: "left", maxWidth: invoiceStartX - 10 });

        doc.setFont("times", 'bold')
        doc.setFontSize(12);
        doc.text(company.bill_to, startX + 2, headingHeight + 12, { align: "left", maxWidth: invoiceStartX - 10 });

        doc.setFont("times", '', 'normal')
        doc.setFontSize(9);
        doc.text(fc.name, startX + 2, headingHeight + 17, { align: "left", maxWidth: invoiceStartX - 10 });
        doc.text(fc.address1, startX + 2, headingHeight + 22, { align: "left", maxWidth: invoiceStartX - 10 });
        doc.text(fc.address2, startX + 2, headingHeight + 27, { align: "left", maxWidth: invoiceStartX - 10 });
        doc.text(fc.address3, startX + 2, headingHeight + 32, { align: "left", maxWidth: invoiceStartX - 10 });
        doc.text(fc.address4, startX + 2, headingHeight + 37, { align: "left", maxWidth: invoiceStartX - 10 });
        doc.text(`GSTIN No: ${fc.gstin}`, startX + 2, headingHeight + 42, { align: "left", maxWidth: invoiceStartX - 10 });

        //Invoice
        doc.setFont("times", 'bold')
        doc.setFontSize(12);
        doc.text(`${shipment.interstate === 1 ? 'Invoice' : 'Challan'} No.`, invoiceStartX + 2, headingHeight + 5, { align: "left", maxWidth: contentEndX - 10 });
        doc.setFont("times", '', 'normal')
        doc.text(shipment.invoice_no, invoiceStartX + 2, headingHeight + 10, { align: "left", maxWidth: contentEndX - 10 });
        if (shipment.interstate === 0) {
            doc.line(invoiceStartX, invoiceStartY - 7, contentEndX, invoiceStartY - 7);
            doc.text(`Vehicle No: ${shipment.vehicle_no || ''}`, invoiceStartX + 2, headingHeight + 18, { align: "left", maxWidth: contentEndX - 10 });
        }

        //Invoice Date
        doc.setFont("times", 'bold')
        doc.setFontSize(12);
        doc.text('Date', invoiceStartX + 2, invoiceStartY + 5, { align: "left", maxWidth: contentEndX - 10 });
        doc.setFont("times", '', 'normal')
        doc.text(getTimeInIST(shipment.shipment_date).format(format_invoice), invoiceStartX + 2, invoiceStartY + 12, { align: "left", maxWidth: contentEndX - 10 });


        //Table Heading
        // let tableHeadingHeight = section2Height - 10;
        let column1X = startX + 2;
        let column2X = invoiceStartX - 46;
        let column3X = invoiceStartX - 23;
        let column4X = invoiceStartX - 10;
        let column5X = invoiceStartX + 2;
        let column6X = contentEndX - 43;
        let column7X = contentEndX - 23;
        let initialTableY = section2Height + 5;
        doc.line(startX, section2Height + 10, contentEndX, section2Height + 10);

        doc.line(contentEndX - 27, section2Height, contentEndX - 27, footerTotalHeightY);
        doc.line(contentEndX - 48, section2Height, contentEndX - 48, footerTotalHeightY);
        doc.line(invoiceStartX, section2Height, invoiceStartX, footerheightY);
        doc.line(invoiceStartX - 13, section2Height, invoiceStartX - 13, footerheightY);
        doc.line(invoiceStartX - 26, section2Height, invoiceStartX - 26, footerheightY);
        doc.line(invoiceStartX - 48, section2Height, invoiceStartX - 48, footerheightY);

        doc.setFont("times", 'bold')
        doc.setFontSize(11);
        doc.text('AMOUNT', column7X, initialTableY, { align: "left", maxWidth: contentEndX - 10 });
        doc.text('RATE', column6X, initialTableY, { align: "left", maxWidth: contentEndX - 25 });
        doc.text('UNITS', column5X, initialTableY, { align: "left", maxWidth: contentEndX - 45 });
        doc.text('QTY', column4X, initialTableY, { align: "left", maxWidth: invoiceStartX + 4 });
        doc.text('GST', column3X, initialTableY, { align: "left", maxWidth: invoiceStartX - 22 });
        doc.text('HSN Code', column2X, initialTableY, { align: "left", maxWidth: invoiceStartX - 24 });
        doc.text('Description of Goods', column1X, initialTableY, { align: "left", maxWidth: invoiceStartX - 50 });

        // Items
        doc.setFont("times", '', 'normal')
        doc.setFontSize(10);
        let item_lineheight = 5;
        let initialTableDataHeight = initialTableY + 10;
        shipment.items.forEach((item, index) => {
            let fnsku = this.state.master_items.filter(i => i.id === item.item_id)[0].fnsku;
            doc.text(`${index + 1}. ${item.item_name} [${fnsku}]`, startX + 1, initialTableDataHeight + (index * item_lineheight), { align: "left", maxWidth: 75 });
            doc.text(`${item.hsn_code}`, column3X - 4, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 23 });
            doc.text(`${shipment.interstate === 1 ? item.igst : parseFloat(item.cgst) + parseFloat(item.sgst)}%`, column4X - 4, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 12 });
            doc.text(`${toInt(item.no_of_cases) * toInt(item.case_size)}`, column5X - 3, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 12 });
            doc.text(`PCS`, column5X + 1, initialTableDataHeight + (index * item_lineheight), { align: "left", maxWidth: 20 });
            this.getRupeeSymbol(doc, column7X - 24, initialTableDataHeight + (index * item_lineheight));
            doc.text(` ${formatNumber(item.rate)}`, column7X - 5, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 20 });
            this.getRupeeSymbol(doc, column7X - 3, initialTableDataHeight + (index * item_lineheight));
            doc.text(` ${formatNumber(parseFloat(item.rate) * toInt(item.no_of_cases) * toInt(item.case_size))}`, contentEndX - 1, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 25 });
        });

        // Items Summary 
        let summaryStart = startX + 1, summaryEnd = contentEndX - 1, summaryHeight = footerheightY - 45;
        let roundOff = 0;
        let total_amount = 0;
        let igst_amount_map = new Map();
        let cgst_amount_map = new Map();
        let sgst_amount_map = new Map();
        total_amount = shipment.items.reduce(function (items, item, idx) {
            return items + ((toInt(item.no_of_cases) * toInt(item.case_size)) * parseFloat(item.rate))
        }, 0);
        if (shipment.interstate === 1) {
            shipment.items.forEach(item => {
                if (!igst_amount_map.has(item.igst)) {
                    igst_amount_map.set(item.igst, 0)
                }
            })
            igst_amount_map.forEach((value, key) => {
                igst_amount_map.set(key, shipment.items.filter(i => parseFloat(i.igst) === parseFloat(key)).reduce(function (items, item, idx) {
                    let tax_rate = parseFloat(item.igst) / 100;
                    return items + ((toInt(item.no_of_cases) * toInt(item.case_size) * item.rate) * tax_rate)
                }, 0))
            });
        } else {
            shipment.items.forEach(item => {
                if (!cgst_amount_map.has(item.cgst)) {
                    cgst_amount_map.set(item.cgst, 0)
                    sgst_amount_map.set(item.sgst, 0)
                }
            })
            cgst_amount_map.forEach((value, key) => {
                cgst_amount_map.set(key, shipment.items.filter(i => parseFloat(i.cgst) === parseFloat(key)).reduce(function (items, item, idx) {
                    let tax_rate = parseFloat(item.cgst) / 100;
                    return items + ((toInt(item.no_of_cases) * toInt(item.case_size) * item.rate) * tax_rate)
                }, 0));
            });
            sgst_amount_map.forEach((value, key) => {
                sgst_amount_map.set(key, shipment.items.filter(i => parseFloat(i.sgst) === parseFloat(key)).reduce(function (items, item, idx) {
                    let tax_rate = parseFloat(item.sgst) / 100;
                    return items + ((toInt(item.no_of_cases) * toInt(item.case_size) * item.rate) * tax_rate)
                }, 0))
            });
        }
        let total_igst = Array.from(igst_amount_map.values()).reduce((sum, next) => sum + next, 0) || 0;
        let total_cgst = Array.from(cgst_amount_map.values()).reduce((sum, next) => sum + next, 0) || 0;
        let total_sgst = Array.from(sgst_amount_map.values()).reduce((sum, next) => sum + next, 0) || 0;
        let total = Math.round(total_amount + (shipment.interstate === 1 ? (total_igst) : (total_cgst + total_sgst)));
        roundOff = total - (total_amount + (shipment.interstate === 1 ? (total_igst) : (precision(total_cgst) + precision(total_sgst))));
        summaryHeight = (total_cgst > 0) ? summaryHeight : summaryHeight + 5;
        doc.setFont("times", 'bold')
        doc.setFontSize(10);
        doc.text('Total Taxable Value', summaryStart, summaryHeight, { align: "left", maxWidth: 77 });
        this.getRupeeSymbol(doc, summaryEnd - 25, summaryHeight);
        doc.text(`${formatNumber(total_amount)}`, summaryEnd, summaryHeight, { align: "right", maxWidth: 25 });

        if (shipment.interstate === 1) {
            let i = 0
            igst_amount_map.forEach((value, key) => {
                doc.text(`ADD IGST  ${key}%`, summaryStart, summaryHeight + 5 + (i * 5), { align: "left", maxWidth: 77 });
                this.getRupeeSymbol(doc, summaryEnd - 25, summaryHeight + 5 + (i * 5));
                doc.text(`${formatNumber(value)}`, summaryEnd, summaryHeight + 5 + (i * 5), { align: "right", maxWidth: 25 });
                i++
            })
        } else {
            let i = 0
            cgst_amount_map.forEach((value, key) => {
                let sgst = sgst_amount_map.get(key)
                doc.text(`ADD CGST  ${key}%`, summaryStart, summaryHeight + 5 + (i * 10), { align: "left", maxWidth: 77 });
                doc.text(`ADD SGST  ${key}%`, summaryStart, summaryHeight + 10 + (i * 10), { align: "left", maxWidth: 77 });

                this.getRupeeSymbol(doc, summaryEnd - 25, summaryHeight + 5 + (i * 10));
                doc.text(`${formatNumber(value)}`, summaryEnd, summaryHeight + 5 + (i * 10), { align: "right", maxWidth: 25 });
                this.getRupeeSymbol(doc, summaryEnd - 25, summaryHeight + 10 + (i * 10));
                doc.text(`${formatNumber(sgst)}`, summaryEnd, summaryHeight + 10 + (i * 10), { align: "right", maxWidth: 25 });
                i++
            })
        }

        let round_off_height = (total_igst === 0) ? summaryHeight + 24 : summaryHeight + 18;
        doc.text('ROUND OFF', summaryStart, round_off_height, { align: "left", maxWidth: 77 });
        this.getRupeeSymbol(doc, summaryEnd - 25, round_off_height);
        doc.text(`${formatNumber(roundOff)}`, summaryEnd, round_off_height, { align: "right", maxWidth: 25 });

        // Items Reference Section
        let referenceStart = startX + 1, referenceHeight = footerheightY - 17;
        doc.setFont("times", 'bold')
        doc.setFontSize(10);
        doc.text('Reference', referenceStart, referenceHeight, { align: "left", maxWidth: 77 });
        doc.setFontSize(12);
        doc.setFont("times", '', 'normal')
        doc.text(`Shipment ID: ${shipment.shipment_identifier || ''}`, referenceStart, referenceHeight + 5, { align: "left", maxWidth: 75 });
        doc.text(`Units: ${total_units}`, referenceStart, referenceHeight + 10, { align: "left", maxWidth: 75 });
        doc.text(`Cartons: ${total_cartons}`, referenceStart, referenceHeight + 15, { align: "left", maxWidth: 75 });


        // Footer
        let totalInWordsSectionX = invoiceStartX - 48;
        let totalInWordsSectionY = footerheightY + 30;
        doc.line(startX, footerheightY, contentEndX, footerheightY);
        doc.line(startX, footerTotalHeightY, contentEndX, footerTotalHeightY);
        doc.line(startX, totalInWordsSectionY, totalInWordsSectionX, totalInWordsSectionY);
        doc.line(startX, totalInWordsSectionY + 11, totalInWordsSectionX, totalInWordsSectionY + 11);
        doc.line(totalInWordsSectionX, footerTotalHeightY, totalInWordsSectionX, contentEndY);

        doc.setFont("times", 'bold')
        doc.setFontSize(10);
        doc.text(`Total`, startX + 2, footerheightY + 6, { align: "left" });
        this.getRupeeSymbol(doc, contentEndX - 26, footerheightY + 5.75);
        doc.text(`${formatNumber(total)}`, contentEndX - 1, footerheightY + 6, { align: "right", maxWidth: 25 });

        doc.setFont("times", '', 'normal')
        doc.setFontSize(10);
        doc.text(`Amount (in words)`, startX + 2, footerheightY + 15, { align: "left" });
        doc.setLineHeightFactor(1)
        doc.text(`Rupees ${titleCase(numberToText(total))} only`, startX + 2, footerheightY + 20, { align: "left", maxWidth: totalInWordsSectionX - 15 });

        doc.setFont("times", 'bold')
        doc.setFontSize(12);
        doc.text(`Company's PAN: ${company.pan}`, startX + 2, totalInWordsSectionY + 7, { align: "left" });
        doc.text(`Buyer's PAN: ${company.pan}`, startX + 2, totalInWordsSectionY + 17, { align: "left" });


        doc.setFont("times", '', 'normal')
        doc.setFontSize(12);
        doc.text(`For ${company.name}`, contentEndX - 5, footerheightY + 24, { align: "right" });
        doc.text(`Authorised Signatory`, contentEndX - 5, totalInWordsSectionY + 15, { align: "right" });


        // doc.output("dataurlnewwindow");


        // doc.save("Invoice-"+shipment.invoice_no);
        // var output = doc.output('datauristring');
        // this.setState({output: output});

        let filename = `${shipment.shipment_identifier || ''}_${shipment.fc_name}_GST${shipment.invoice_no.substring(shipment.invoice_no.lastIndexOf("/") + 1)}_Invoice.pdf`;
        doc.save(filename);
    }

    getRupeeSymbol(doc, x, y) {
        doc.text('INR', x, y);
        // let rupee = "data:image/png;base64,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";
        // doc.addImage(rupee, 'PNG', column7X - 24, initialTableDataHeight + (index * item_lineheight) - 2.5, 2.5, 2.5);
    }

    saveAppointment(date) {
        this.props.isLoading(true);
        this.setState(old => ({ shipment_details: { ...old.shipment_details, appointment: date } }))
        ShipmentService.updateAppointmentDate({ appointment: moment(date).format(format_without_time), shipment_identifier: this.state.shipment_details.shipment_identifier, id: this.state.shipment_details.id })
            .then((data) => {
                this.props.isLoading(false);
                this.setState({ reload: true })
                if (data.success) {
                    this.props.showSnackBar("Updated", 'success');
                }
            })
            .catch((error) => {
                this.props.isLoading(false);
                this.props.showSnackBar("Something went wrong. Please try again", 'error');
                console.log(error);
            });
    }

    uploadAppointmentDocument(event) {
        let files = event.target.files;
        if (files.length === 1) {
            let reader = new FileReader();
            reader.readAsDataURL(files[0]);
            let name = files[0].name;
            reader.onload = (e) => {
                this.props.isLoading(true);
                ShipmentService.uploadAppointmentDoc({ name: name, file: e.target.result, shipment_identifier: this.state.shipment_details.shipment_identifier, id: this.state.shipment_details.id })
                    .then((data) => {
                        this.props.isLoading(false);
                        if (data.success) {
                            this.props.showSnackBar("Uploaded", 'success');
                            this.setState(old => ({ shipment_details: { ...old.shipment_details, appointment_doc: data.download_url }, reload: true }))
                        }
                    })
                    .catch((error) => {
                        this.props.isLoading(false);
                        this.props.showSnackBar("File import failed. Please try again. Check Extension and file name.", 'error');
                        console.log(error);
                    });
            }
        }
    }

    uploadSignedDocument(event) {
        let files = event.target.files;
        if (files.length === 1) {
            let reader = new FileReader();
            reader.readAsDataURL(files[0]);
            let name = files[0].name;
            reader.onload = (e) => {
                this.props.isLoading(true);
                ShipmentService.uploadSignedDoc({ name: name, file: e.target.result, shipment_identifier: this.state.shipment_details.shipment_identifier, id: this.state.shipment_details.id })
                    .then((data) => {
                        this.props.isLoading(false);
                        if (data.success) {
                            this.props.showSnackBar("Uploaded", 'success');
                            this.setState(old => ({ shipment_details: { ...old.shipment_details, signed_doc: data.download_url }, reload: true }))
                        }
                    })
                    .catch((error) => {
                        this.props.isLoading(false);
                        this.props.showSnackBar("File import failed. Please try again. Check Extension and file name.", 'error');
                        console.log(error);
                    });
            }
        }
    }

    removeItemImage(id) {
        this.props.showConfirmDialog("Confirm remove?", undefined, () => {
            this.props.closeConfirmDialog();
            this.props.isLoading(true);
            ShipmentService.removeShipmentImage(id)
                .then((data) => {
                    this.props.isLoading(false);
                    if (data.success) {
                        this.props.showSnackBar("Removed", 'success');
                        this.refresh()
                    }
                })
                .catch((error) => {
                    this.props.isLoading(false);
                    this.props.showSnackBar("File import failed. Please try again. Check Extension and file name.", 'error');
                    console.log(error);
                });
        });
    }

    downloadShippedDocument() {
        const shipment = this.state.shipment_details;
        let filename = `Shipment Weight_${shipment.shipment_identifier || ''}_${shipment.fc_name}_${moment().format("DD.MM.YY")}.pdf`;
        ShipmentService.getShipmentDoc(this.state.shipment_details.id)
            .then(response => {
                return response.blob()
            })
            .then((blob) => {
                this.props.isLoading(false);
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                // Shipment Weight_FBA15DMN8LZY_DEL2_17.03.21.pdf
                link.setAttribute('download', filename);
                // 3. Append to html page
                document.body.appendChild(link);
                // 4. Force download
                link.click();
                // 5. Clean up and remove the link
                link.parentNode.removeChild(link);
            })
            .catch(error => {
                this.props.isLoading(false);
                console.log(error);
            });
    }

    exportReport = async () => {
        let sort = this.state.orderBy ? this.state.orderBy : '', direction = this.state.order ? this.state.order : '';
        let warehouse_id = this.state.selected_warehouse === "" ? null : this.state.selected_warehouse;
        let fc_id = this.state.selected_fc === "" ? null : this.state.selected_fc;
        let item_id = this.state.selected_item_id === "" ? null : this.state.selected_item_id;
        let status = this.state.selected_status === "-1" ? '0,1,2,3' : this.state.selected_status;
        let filter = this.state.filter === "" ? null : this.state.filter;
        let interstate = this.state.selected_interstate === "" ? null : this.state.selected_interstate;
        if (!warehouse_id) {
            this.props.showSnackBar('Please select warehouse and continue', 'error');
        } else {
            this.props.isLoading(true);
            let fileName = `Shipments-${moment.utc(this.state.startDate).format(format_export_new)}-${moment.utc(this.state.endDate).format(format_export_new)}.xlsx`;
            ShipmentService.getExport(0, this.state.totalItems, moment.utc(this.state.startDate).format(format), moment.utc(this.state.endDate).format(format), warehouse_id, fc_id, interstate, status, item_id, filter, sort, direction)
                .then(response => {
                    return response.blob();
                })
                .then((blob) => {
                    this.props.isLoading(false);
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    // 3. Append to html page
                    document.body.appendChild(link);
                    // 4. Force download
                    link.click();
                    // 5. Clean up and remove the link
                    link.parentNode.removeChild(link);
                })
                .catch(error => {
                    this.props.isLoading(false);
                    console.log(error);
                });
        }
    }

    handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = this.state.current_rows.map((n) => n.id);
            this.setState({ selected: newSelecteds });
            return;
        }
        this.setState({ selected: [] });
    };

    render() {
        const { classes } = this.props;
        const { selected, current_rows, showShipmentDetails } = this.state;
        return (
            <div className="Home">
                {/* <div>
                    <TextField
                        style={{ marginRight: 32, marginTop: 16, marginBottom: 0, width: '98%', marginLeft: 12 }}
                        id="outlined-search"
                        label="Search"
                        onChange={this.handleChangeSearchText}
                        className={classnames(classes.formControlLeft, classes.formControl)}
                        margin="normal"
                        variant="outlined"
                        helperText="Search by Shipment ID, Invoice No Or Vehicle No"
                        />
                </div> */}
                <FormControl size="small" variant="outlined" className={classnames(classes.formControlLeft, classes.formControl)} style={{ float: "left" }}>
                    <InputLabel
                        ref={ref => {
                            this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-warehouse-simple"
                    >
                        Warehouse
                    </InputLabel>
                    <Select
                        value={this.state.selected_warehouse}
                        onChange={this.handleWarehouseSelection}
                        input={
                            <OutlinedInput
                                labelWidth={80}
                                name="Warehouse"
                                id="outlined-warehouse-simple"
                            />
                        }
                    >
                        {this.state.warehouse_names}
                    </Select>
                </FormControl>
                <FormControl size="small" variant="outlined" className={classes.formControl} style={{ float: "left" }}>
                    <InputLabel
                        ref={ref => {
                            this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-fc-simple"
                    >
                        FC
                    </InputLabel>
                    <Select
                        value={this.state.selected_fc}
                        onChange={this.handleFCSelection}
                        input={
                            <OutlinedInput
                                labelWidth={20}
                                name="FC"
                                id="outlined-fc-simple"
                            />
                        }
                    >
                        {this.state.fc_names}
                    </Select>
                </FormControl>
                <FormControl size="small" variant="outlined" className={classes.formControl} style={{ float: "left" }}>
                    <InputLabel
                        ref={ref => {
                            this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-status-simple"
                    >
                        Status
                    </InputLabel>
                    <Select
                        value={this.state.selected_status}
                        onChange={this.handleStatusSelection}
                        input={
                            <OutlinedInput
                                labelWidth={50}
                                name="Status"
                                id="outlined-txn_type-simple"
                            />
                        }
                    >
                        {this.state.master_status}
                    </Select>
                </FormControl>
                <FormControl size="small" variant="outlined" className={classes.formControl} style={{ float: "left" }}>
                    <InputLabel
                        ref={ref => {
                            this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-interstate-simple"
                    >
                        Interstate
                    </InputLabel>
                    <Select
                        value={this.state.selected_interstate}
                        onChange={this.handleInterstateSelection}
                        input={
                            <OutlinedInput
                                labelWidth={70}
                                name="Status"
                                id="outlined-interstate-simple"
                            />
                        }
                    >
                        {this.state.master_interstate_rows}
                    </Select>
                </FormControl>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <DatePicker
                        margin="normal"
                        label="From"
                        value={this.state.startDate}
                        onChange={this.handleChangeStartDate}
                        format='DD MMM YYYY'
                        maxDate={this.state.endDate}
                        variant="dialog"
                        size="small"
                        inputVariant="outlined"
                        className={classes.formControl}
                        style={{ float: "left", height: "100%", marginTop: "24px" }}
                    />
                    <DatePicker
                        margin="normal"
                        label="To"
                        size="small"
                        value={this.state.endDate}
                        onChange={this.handleChangeEndDate}
                        format='DD MMM YYYY'
                        variant="dialog"
                        inputVariant="outlined"
                        minDate={this.state.startDate}
                        className={classes.formControl}
                        style={{ float: "left", height: "100%", marginTop: "24px" }}
                    />
                </MuiPickersUtilsProvider>
                <div className="container">
                    <Paper className={this.props.classes.root} style={{ width: "100%", marginTop: "50px", paddingLeft: "5px", paddingRight: "5px", marginBottom: 75 }}>
                        <EnhancedTableToolbar
                            searchText={this.state.filter}
                            onSearchTextChange={this.handleChangeSearchText}
                            searchPlaceholder="Shipment ID, Invoice No Or Vehicle No"
                            exportReport={this.exportReport}
                            numSelected={selected.length}
                            SelectionComponent={() => (
                                <div style={{ flex: '1 5 100%' }}>
                                    <Typography color="inherit" variant="subtitle1" component="span">
                                        Shipment Details
                                    </Typography>
                                    <Tooltip title="Download">
                                        <IconButton aria-label="delete" onClick={() => this.setState({ showShipmentDetails: true })}>
                                            <Icon>save_alt</Icon>
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            )}
                        />
                        <TableContainer>
                            <Table className={classes.table}>
                                <EnhancedTableHead
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onRequestSort={this.sortBy}
                                    rows={this.state.columns}
                                    numSelected={selected.length}
                                    checkboxSelection
                                    onSelectAllClick={this.handleSelectAllClick}
                                    rowCount={current_rows.length} />
                                <TableBody>
                                    {current_rows.map((shipment) => (
                                        <ShipmentDetails handleClick={this.handleClick} isSelected={this.isSelected} classes={this.props.classes} key={shipment.id} shipment={shipment} changeStatus={this.changeStatus} printLabel={this.printLabel} printInvoice={this.printInvoice} edit={this.edit} showPackingList={this.showPackingList} duplicateShipment={this.duplicateShipment} showDetails={this.showDetails} removeShipment={this.removeShipment} />
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={RowCountOptions}
                            component="div"
                            count={this.state.totalItems}
                            rowsPerPage={this.state.numItemsPerPage}
                            page={this.state.currentPageNumber}
                            backIconButtonProps={{
                                'aria-label': 'Previous Page',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Next Page',
                            }}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                        />
                    </Paper>
                </div>
                <DialogMUI
                    fullScreen
                    TransitionComponent={Transition}
                    open={this.state.show}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                Shipment
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    {/* <DialogTitle id="alert-dialog-title">Create Transaction</DialogTitle> */}
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" component={'span'}>
                            <TextField
                                id="shipment_identifier"
                                label="Shipment ID"
                                placeholder="Shipment ID"
                                name="shipment_identifier"
                                defaultValue={this.state.new_shipment.shipment_identifier}
                                className={this.props.classes.textField}
                                margin="normal"
                                variant="outlined"
                                onChange={this.handleChange}
                                required
                                error={this.state.error_fields.shipment_identifier}
                                helperText="Enter Shipment ID"
                                type="text"
                                style={{ marginTop: '8px' }}
                            />
                            <TextField
                                id="invoice_no"
                                label="Invoice No"
                                placeholder="Invoice No"
                                name="invoice_no"
                                defaultValue={this.state.new_shipment.invoice_no}
                                className={this.props.classes.textField}
                                margin="normal"
                                variant="outlined"
                                onChange={this.handleChange}
                                required
                                error={this.state.error_fields.invoice_no}
                                helperText="Enter Invoice No"
                                type="text"
                                style={{ marginTop: '8px' }}
                            />
                            <SelectDropdown required error={this.state.error_fields.warehouse_id} disabled={this.state.master_warehouse.length === 0} label="Warehouse" hint="Select Warehouse" name="warehouse_id" options={this.state.master_warehouse} value={this.state.new_shipment.warehouse_id} onChange={this.handleChange} />
                            <SelectDropdown required error={this.state.error_fields.fc_id} label="FC" hint="Select FC" name="fc_id" options={this.state.master_fc} value={this.state.new_shipment.fc_id} onChange={this.handleChange} />
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    margin="normal"
                                    label="Shipment Date"
                                    value={this.state.new_shipment.shipment_date}
                                    onChange={this.handleChangeShipmentDate}
                                    format='DD MMM YYYY'
                                    minDate={this.props.user.roles.includes(ROLES.ADMIN) ? undefined : moment()}
                                    variant="dialog"
                                    inputVariant="outlined"
                                    style={{ marginTop: "8px" }}
                                    helperText={`Select Shipment Date ${this.props.user.roles.includes(ROLES.ADMIN) && " - No restriction for admin users"}`}
                                />
                            </MuiPickersUtilsProvider>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={this.state.new_shipment.interstate === "1"}
                                        onChange={this.handleChange}
                                        name='interstate'
                                        value={this.state.new_shipment.interstate}
                                    />
                                }
                                style={{ marginTop: 10, marginLeft: 8, marginRight: 8 }}
                                label="Interstate"
                            />
                            {
                                this.state.new_shipment.interstate === 0 &&
                                <TextField
                                    id="vehicle_no"
                                    label="Vehicle No"
                                    placeholder="Vehicle No"
                                    name="vehicle_no"
                                    defaultValue={this.state.new_shipment.vehicle_no}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    helperText="Enter Vehicle No"
                                    type="text"
                                    style={{ marginTop: '8px' }}
                                />
                            }
                            <Divider />
                            <List className={this.props.classes.list}>
                                {this.state.item_rows}
                            </List>
                        </DialogContentText>
                        <Fab onClick={this.handleAddItemClick} variant="extended" color="secondary" aria-label="Add Item" className={classes.fab} style={{ position: 'fixed', top: '80%', left: '88%' }}>
                            <AddIcon />
                            Add Item
                        </Fab>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Close
                        </Button>
                        <Button onClick={this.createModifyShipment} color="primary" autoFocus>
                            Save
                        </Button>
                    </DialogActions>
                </DialogMUI>
                {this.state.shipment_details &&
                    <DialogMUI
                        fullWidth
                        maxWidth={'lg'}
                        TransitionComponent={Transition}
                        open={this.state.showDetails}
                        onClose={this.handleCloseDetails}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        scroll='paper'>
                        <AppBar className={classes.appBar}>
                            <Toolbar>
                                <IconButton color="inherit" onClick={this.handleCloseDetails} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" color="inherit" className={classes.flex}>
                                    Shipment Details
                                </Typography>
                            </Toolbar>
                        </AppBar>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" component={'span'}>
                                <Grid container spacing={1} style={{ flexGrow: 1, marginLeft: 10, marginBottom: 15 }} justifyContent="flex-start" alignItems="center">
                                    <Grid item xs={3}>
                                        <Typography variant="subtitle1" className={classes.heading}>Shipment ID</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        {this.state.shipment_details.shipment_identifier}
                                    </Grid>
                                    <Grid item xs={3} />
                                    <Grid item xs={3} >
                                        {this.state.shipment_details.interstate === 1 ? <Avatar className={classes.orangeAvatar}>INT</Avatar> : <Avatar className={classes.purpleAvatar}>LOC</Avatar>}
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <Typography variant="subtitle1" className={classes.heading}>Invoice No</Typography>
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        {this.state.shipment_details.invoice_no}
                                    </Grid>
                                    <Hidden mdDown>
                                        <Grid item xs={6} />
                                    </Hidden>
                                    <Grid item xs={6} md={3}>
                                        <Typography variant="subtitle1" className={classes.heading}>Shipment Date</Typography>
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        {getTimeInIST(this.state.shipment_details.shipment_date).format(format_invoice)}
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <DatePicker
                                                margin="dense"
                                                label="Appointment Date"
                                                value={this.state.shipment_details ? (this.state.shipment_details.appointment || null) : null}
                                                onChange={(date) => this.saveAppointment(date)}
                                                format='DD MMM YYYY'
                                                minDate={this.props.user.roles.includes(ROLES.ADMIN) ? undefined : moment()}
                                                variant="dialog"
                                                inputVariant="outlined"
                                                helperText={this.props.user.roles.includes(ROLES.ADMIN) && `No restriction for admin`}
                                                InputProps={{
                                                    endAdornment: (
                                                        <IconButton color="inherit" style={{ padding: 0 }}>
                                                            <CalendarIcon />
                                                        </IconButton>
                                                    )
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Hidden mdDown>
                                        <Grid item md={3} />
                                    </Hidden>
                                    <Grid item xs={6} md={3}>
                                        <Typography variant="subtitle1" className={classes.heading}>Warehouse</Typography>
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        {this.state.shipment_details.warehouse_name}
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="subtitle1" className={classes.heading} style={{ marginRight: 16 }}>{this.state.shipment_details.appointment_doc ? `Replace` : `Add`} Appointment Doc</Typography>
                                        <Tooltip title="Click to upload document">
                                            <label htmlFor="appointment-doc-button-file">
                                                <UploadIcon />
                                                <input onChange={this.uploadAppointmentDocument} id="appointment-doc-button-file" type="file" name="appointment_doc" accept=".pdf" multiple={false} ref={this.fileInput} style={{ display: 'none' }} />
                                            </label>
                                        </Tooltip>
                                        {this.state.shipment_details.appointment_doc && (
                                            <Tooltip title="Click to download document">
                                                <IconButton style={{ padding: 0, marginLeft: 12, marginBottom: 16 }} color="inherit" onClick={() => window.open(this.state.shipment_details.appointment_doc)} aria-label="Close">
                                                    <DownloadIcon />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <Typography variant="subtitle1" className={classes.heading}>Fulfillment Center</Typography>
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        {this.state.shipment_details.fc_name}
                                    </Grid>
                                    <Grid item xs={12} md={6} />
                                    {this.state.shipment_details.vehicle_no &&
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle1" className={classes.heading}>Vehicle No</Typography>
                                        </Grid>
                                    }
                                    {this.state.shipment_details.vehicle_no &&
                                        <Grid item xs={3}>
                                            {this.state.shipment_details.vehicle_no}
                                        </Grid>
                                    }
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="subtitle1" component="span" className={classes.heading} style={{ marginRight: 16 }}>Download Shipped Document</Typography>
                                        <IconButton color="inherit" onClick={this.downloadShippedDocument} aria-label="Close">
                                            <DownloadIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="subtitle1" className={classes.heading} style={{ marginRight: 16 }}>{this.state.shipment_details.signed_doc ? `Replace` : `Add`} Signed & Scanned Doc</Typography>
                                        <Tooltip title="Click to upload document">
                                            <label htmlFor="signed-doc-button-file">
                                                <UploadIcon />
                                                <input onChange={this.uploadSignedDocument} id="signed-doc-button-file" type="file" name="appointment_doc" accept=".pdf" multiple={false} ref={this.fileInput} style={{ display: 'none' }} />
                                            </label>
                                        </Tooltip>
                                        {this.state.shipment_details.signed_doc && (
                                            <Tooltip title="Click to download document">
                                                <IconButton style={{ padding: 0, marginLeft: 12, marginBottom: 16 }} color="inherit" onClick={() => window.open(this.state.shipment_details.signed_doc)} aria-label="Close">
                                                    <DownloadIcon />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </Grid>
                                </Grid>
                                <Divider />
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow>
                                            <CustomTableCell></CustomTableCell>
                                            <CustomTableCell>Item</CustomTableCell>
                                            <CustomTableCell align="left" padding='none'>FNSKU</CustomTableCell>
                                            <CustomTableCell align="right" padding='none'>HSN Code</CustomTableCell>
                                            <CustomTableCell align="right" padding='none'>Rate</CustomTableCell>
                                            <CustomTableCell align="right" padding='none'>Case size</CustomTableCell>
                                            <CustomTableCell align="right" padding='none'>No of Cases</CustomTableCell>
                                            <CustomTableCell align="right" padding='none'>Weight of each Case</CustomTableCell>
                                            <CustomTableCell align="right" style={{ paddingLeft: 5 }}>dimension</CustomTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.shipment_details_rows}
                                    </TableBody>
                                </Table>
                                {
                                    this.state.shipment_details.items && (
                                        <ImageList cols={4} rowHeight={180} className={classes.imageList}>
                                            {this.state.shipment_details.items.map(row => row.images).reduce((sum, next) => [...sum, ...next], []).map((item) => (
                                                <ImageListItem key={item.id}>
                                                    <img src={item.link} alt={item.link} height="100" />
                                                    <ImageListItemBar
                                                        title={`Weight: ${item.weight}`}
                                                        actionIcon={
                                                            <Tooltip title="Remove image">
                                                                <IconButton onClick={() => this.removeItemImage(item.id)} className={classes.icon} style={{ color: grey[300] }}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        }
                                                    />
                                                </ImageListItem>
                                            ))}
                                        </ImageList>
                                    )
                                }
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseDetails} color="primary">
                                Close
                            </Button>
                        </DialogActions>
                    </DialogMUI>
                }
                <DialogMUI
                    open={this.state.showChangeStatus}
                    onClose={this.handleCloseChangeStatus}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                    <DialogTitle id="alert-dialog-title">Change Status</DialogTitle>
                    <DialogContent style={{ minWidth: "300px" }}>
                        <Select
                            value={this.state.selected_shipment.status}
                            onChange={(e) => this.changeStatusForShipment(e)}
                            input={
                                <OutlinedInput
                                    labelWidth={200}
                                    name="Status"
                                    id="outlined-status-simple"
                                />
                            }
                            style={{ width: '100%' }}
                        >
                            <MenuItem value={"0"}>{convertShipmentStatusToString("0")}</MenuItem>
                            <MenuItem value={"1"}>{convertShipmentStatusToString("1")}</MenuItem>
                            <MenuItem value={"2"}>{convertShipmentStatusToString("2")}</MenuItem>
                            <MenuItem value={"3"}>{convertShipmentStatusToString("3")}</MenuItem>
                        </Select>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseChangeStatus} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </DialogMUI>
                <DialogMUI
                    open={this.state.showAddItem}
                    onClose={this.handleCloseAddItemShipment}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                    <DialogTitle id="alert-dialog-title" style={{ paddingBottom: 5 }}>Select Item</DialogTitle>
                    <DialogContent>
                        <FormControl className={classes.formControl} style={{ minWidth: "300px", minHeight: 150 }}>
                            <AutoCompleteSelection
                                menuIsOpen={true}
                                placeHolder="Select Item"
                                onChange={this.handleAddItemToShipment}
                                name="items"
                                value={[]}
                                error={this.state.error_fields.items}
                                options={this.state.master_items.filter((item) => this.state.new_shipment.items.filter((i) => i.item_id === item.id && toInt(i.status) === 1).length === 0).map(item => ({
                                    id: item.id,
                                    name: item.name,
                                    value: item.id,
                                    label: `${item.name} [${item.fnsku}]`,
                                    status: item.status
                                }))} />
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseAddItemShipment} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </DialogMUI>
                <DialogMUI
                    fullScreen
                    TransitionComponent={Transition}
                    open={this.state.showOutput}
                    onClose={this.handleCloseOutput}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                    <DialogContent>
                        <AppBar className={classes.appBar}>
                            <Toolbar>
                                <IconButton color="inherit" onClick={this.handleCloseOutput} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" color="inherit" className={classes.flex}>
                                    Print
                                </Typography>
                            </Toolbar>
                        </AppBar>
                        <embed width='100%' height='700px' src={this.state.output} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseOutput} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </DialogMUI>
                {this.state.master_warehouse.length !== 0 && this.state.master_fc.length !== 0 && this.state.master_items.length !== 0 &&
                    <Fab variant="extended" size="medium" onClick={this.edit} color="primary" aria-label="Add" className={this.props.classes.fab} style={{ position: 'fixed', top: '90%', left: '85%' }}>
                        <AddIcon />
                        Create Shipment
                    </Fab>
                }
                <ShipmentDetailExport
                    open={showShipmentDetails}
                    onClose={() => this.setState({ showShipmentDetails: false })}
                    data={current_rows.filter(row => selected.includes(row.id))}
                    showSnackBar={this.props.showSnackBar}
                />
            </div>
        );
    }

}

class ShipmentDetails extends Component {

    render() {
        const { shipment, isSelected, handleClick } = this.props;
        const classes = this.props.classes;
        const labelId = `enhanced-table-checkbox-${shipment.id}`;

        return (
            <TableRow key={shipment.id}>
                <TableCell padding="checkbox">
                    <Checkbox
                        checked={isSelected(shipment.id)}
                        onClick={(e) => handleClick(e, shipment.id)}
                        inputProps={{ 'aria-labelledby': labelId }}
                    />
                </TableCell>
                <TableCell scope="row" align="center" padding='none'>
                    {shipment.interstate === 1 ? <Avatar className={classes.orangeAvatar}>INT</Avatar> : <Avatar className={classes.purpleAvatar}>LOC</Avatar>}
                </TableCell>
                <TableCell component="th" scope="row" align="center" padding='none'>
                    <Typography variant="subtitle2">{shipment.shipment_identifier}</Typography>
                </TableCell>
                <TableCell align="center" padding='none'><Typography variant="subtitle2"> {shipment.invoice_no}</Typography></TableCell>
                <TableCell align="center" padding='none'><Typography variant="subtitle2">{shipment.warehouse_name}</Typography></TableCell>
                <TableCell align="center" padding='none'><Typography variant="subtitle2">{shipment.fc_name}</Typography></TableCell>
                <TableCell align="center" padding='none'>
                    <Typography variant="body1" color="textSecondary">{toInt(shipment.interstate) === 1 ? "Interstate" : "Local"}</Typography>
                    {shipment.vehicle_no && <Typography variant="subtitle2" color="textSecondary">{shipment.vehicle_no}</Typography>}
                </TableCell>
                <TableCell align="center" padding='none'>{getTimeInIST(shipment.shipment_date).format(format_display)}</TableCell>
                <TableCell align="center" padding='none' style={{ paddingTop: 10 }}>
                    {shipment.appointment && shipment.appointment_doc ? <CheckCircleIcon style={{ color: green[500] }} /> : <CancelIcon style={{ color: red[500] }} />}
                </TableCell>
                <TableCell align="center" padding='none' style={{ paddingTop: 10 }}>
                    {shipment.signed_doc ? <CheckCircleIcon style={{ color: green[500] }} /> : <CancelIcon style={{ color: red[500] }} />}
                </TableCell>
                <TableCell align="center" padding='none' style={{ paddingTop: 10 }}>
                    <Typography variant="subtitle2" onClick={(e) => this.props.changeStatus(e, shipment)}>
                        {getShipmentStatusBadge(shipment.status)}
                        <br />
                        {getTimeInIST(shipment.modified_date).format(format_display)}
                    </Typography>
                </TableCell>
                <TableCell align="right" padding='none'>
                    <div style={{ marginTop: 5 }}>
                        <Tooltip title="View Details" arrow>
                            <IconButton size="small" variant="outlined" style={{ marginRight: 10 }} onClick={(e) => this.props.showDetails(e, shipment)}>
                                <ViewListIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="View Label" arrow>
                            <IconButton size="small" variant="outlined" style={{ marginRight: 10 }} onClick={(e) => this.props.printLabel(e, shipment)}>
                                <LabelIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="View Invoice & Packing List" arrow>
                            <IconButton size="small" variant="outlined" style={{ marginRight: 10 }} onClick={(e) => this.props.printInvoice(e, shipment)}>
                                <ReceiptIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {/* <Tooltip title="Packing List" arrow>
                            <IconButton size="small" color="primary"  style={{marginRight: 10}} onClick={(e) => this.props.showPackingList(e, shipment)}>
                                <FormatListNumberedIcon />
                            </IconButton>
                        </Tooltip> */}
                        <Tooltip title="Duplicate Shipment" arrow>
                            <IconButton size="small" style={{ marginRight: 10 }} onClick={(e) => this.props.duplicateShipment(e, shipment)}>
                                <FileCopyIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {shipment.status !== '2' && shipment.status !== '3' &&
                            <Tooltip title="Edit" arrow>
                                <IconButton size="small" variant="contained" style={{ marginRight: 10 }} onClick={(e) => this.props.edit(e, shipment)}>
                                    <Icon fontSize="small">edit</Icon>
                                </IconButton>
                            </Tooltip>
                        }
                        {
                            shipment.status !== '2' &&
                            <Tooltip title="Remove Shipment" arrow>
                                <IconButton size="small" color="secondary" style={{ marginRight: 10 }} onClick={(e) => this.props.removeShipment(e, shipment)}>
                                    <Icon fontSize="small">delete</Icon>
                                </IconButton>
                            </Tooltip>
                        }
                    </div>
                </TableCell>
            </TableRow>
        );
    }
}

class ItemDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            handleItemChange: props.handleItemChange
        }
    }


    handleChange = (e, field) => {
        this.state.handleItemChange(e, field);
        if (field !== 'dimension') {
            if ((parseFloat(e.target.value) || 0) <= 0) {
                this.setState({ error: true });
            } else {
                this.setState({ error: false });
            }
        } else {
            if (e.target.value.length === 0) {
                this.setState({ error: true });
            } else {
                this.setState({ error: false });
            }
        }

    }

    render() {
        const item = this.props.item;
        const item_details = this.props.master_items.filter(i => i.id === item.item_id)[0];
        return (
            <ListItem key={item.item_id} role={undefined} dense button>
                <ListItemText primary={<Typography type="subtitle1">{item.item_name}</Typography>}
                    secondary={<Typography type="title"><b>FNSKU:</b> {item_details.fnsku}</Typography>} style={{ width: "10%" }} />
                <ListItemText primary={<Typography type="title"><b>HSN:</b> {item_details.hsn_code}</Typography>} style={{ width: "5%" }} />
                <ListItemText primary={<Typography type="title"><b>Rate:</b> {item.rate || item_details.rate}</Typography>} style={{ width: "5%" }} />
                <TextField
                    label="Case Size"
                    error={this.state.error}
                    defaultValue={item.case_size}
                    onChange={(e) => this.handleChange(e, 'case_size')}
                    type="number"
                    name={item.item_id}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    className={this.props.classes.qtyField}
                    margin="normal"
                    variant="outlined"
                    required
                    helperText="Enter case size"
                />
                <TextField
                    label="No of cases"
                    error={this.state.error}
                    defaultValue={item.no_of_cases}
                    onChange={(e) => this.handleChange(e, 'no_of_cases')}
                    type="number"
                    name={item.item_id}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    className={this.props.classes.qtyField}
                    margin="normal"
                    variant="outlined"
                    required
                    helperText="Enter No of cases"
                />
                <TextField
                    label="Weight"
                    error={this.state.error}
                    defaultValue={item.weight}
                    onChange={(e) => this.handleChange(e, 'weight')}
                    type="number"
                    name={item.item_id}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    className={this.props.classes.qtyField}
                    margin="normal"
                    variant="outlined"
                    required
                    helperText="Case Weight"
                />
                <TextField
                    label="Dimensions"
                    error={this.state.error}
                    defaultValue={item.dimension}
                    onChange={(e) => this.handleChange(e, 'dimension')}
                    type="text"
                    name={item.item_id}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        maxLength: 20
                    }}
                    className={this.props.classes.qtyField}
                    margin="normal"
                    variant="outlined"
                    required
                    helperText="L x W x H"
                />
                {/* <ListItemText primary={item.qty} style={{width: "30%"}}/> */}
                <ListItemSecondaryAction>
                    {/* <IconButton aria-label="Edit" onClick={(e) => this.props.editItem(e, item)} className={this.props.classes.icon}>
                        <EditIcon />
                    </IconButton> */}
                    <IconButton aria-label="Delete" onClick={(e) => this.props.removeItem(e, item)} className={this.props.classes.icon}>
                        <DeleteIcon />
                    </IconButton>
                </ListItemSecondaryAction>
            </ListItem>
        );
    }
}

class ItemDisplayDetails extends Component {

    constructor(props) {
        super(props)
        this.state = {
            link: null,
            openPreview: false,
            weight: 0,
            file: null,
            loading: false
        }
        this.uploadImage = this.uploadImage.bind(this)
        this.onSave = this.onSave.bind(this)
    }

    uploadImage(event) {
        const fileUploaded = event.target.files[0];
        if (fileUploaded) {
            this.setState({ link: URL.createObjectURL(fileUploaded), openPreview: true, file: fileUploaded });
        }
    }

    onSave() {
        if (this.state.file && this.state.weight) {
            const item = this.props.item;
            let reader = new FileReader();
            reader.readAsDataURL(this.state.file);
            let name = this.state.file.name;
            reader.onload = (e) => {
                this.setState({ loading: true })
                ShipmentService.uploadItemImage({ name: name, file: e.target.result, shipment_id: item.shipment_id, item_id: item.item_id, weight: this.state.weight })
                    .then(() => {
                        this.setState({ link: null, openPreview: false, file: null, weight: 0 });
                        this.props.refresh && this.props.refresh()
                    })
                    .catch((e) => {
                        console.log(e)
                    })
                    .finally(() => this.setState({ loading: false }))
            }
        }
    }

    render() {
        const item = this.props.item;
        const interstate = this.props.interstate;
        const classes = this.props.classes;
        const item_details = this.props.master_items.filter(i => i.id === item.item_id)[0];
        return (
            <TableRow key={item.item_id} className={classes.row}>
                <CustomTableCell style={{ paddingRight: 5 }}>
                    {
                        (item.images ? item.images.length : 0) < item.no_of_cases && (
                            <label htmlFor={`image-${item.item_id}`}>
                                <UploadIcon fontSize='small' />
                                <input onChange={this.uploadImage} id={`image-${item.item_id}`} type="file" name="item-image" accept="image/*" multiple={false} style={{ display: 'none' }} />
                            </label>
                        )
                    }
                    <div>Uploaded: {item.images ? item.images.length : 0}/{item.no_of_cases}</div>
                </CustomTableCell>
                <CustomTableCell style={{ paddingRight: 5 }}>
                    <ListItemText
                        primary={item.item_name}
                        secondary={interstate ? `IGST : ${item.igst}` : `CGST : ${item.cgst} SGST : ${item.sgst}`}
                        style={{ width: 140, paddingRight: 5 }} />
                </CustomTableCell>
                <CustomTableCell align="left" padding='none'>{item_details.fnsku}</CustomTableCell>
                <CustomTableCell align="right" padding='none'>{item_details.hsn_code}</CustomTableCell>
                <CustomTableCell align="right" padding='none'>{formatNumber(item.rate)}</CustomTableCell>
                <CustomTableCell align="right" padding='none'>{item.case_size}</CustomTableCell>
                <CustomTableCell align="right" padding='none'>{item.no_of_cases}</CustomTableCell>
                <CustomTableCell align="right" padding='none'>{item.weight}</CustomTableCell>
                <CustomTableCell align="right" style={{ paddingLeft: 5 }}>{item.dimension || '-'}</CustomTableCell>
                <MyDialog
                    maxWidth={"xs"}
                    content={
                        <div style={{ width: 200, height: 200 }}>
                            {this.state.loading ? (
                                <div style={{ position: "absolute", top: '50%', left: "50%" }}>
                                    <HourglassEmptyIcon />
                                </div>
                            ) : (
                                <div>
                                    <img
                                        src={this.state.link}
                                        height="300" width="300"
                                        alt="" />

                                    <div style={{ width: '100%' }}>
                                        <TextField
                                            label="Weight"
                                            onChange={(e) => this.setState({ weight: e.target.value })}
                                            type="number"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            margin="normal"
                                            variant="outlined"
                                            required
                                            helperText="Actual Weight"
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                </div>
                            )
                            }
                        </div>
                    }
                    title={item.item_name}
                    open={this.state.openPreview}
                    options={<Button variant='contained' color="primary" disabled={this.state.loading} onClick={this.onSave}>Save</Button>}
                    loading={this.state.loading}
                    close={() => {
                        this.setState({ link: null, openPreview: false, file: null, weight: 0 });
                    }} />
            </TableRow>
        );
    }
}

export default withStyles(styles)(Shipment);